import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, takeUntil, withLatestFrom } from 'rxjs';
import * as fromRoot from '@app/reducers/index';
import { Store } from '@ngrx/store';
import { AccountActions } from '@app/core/actions';
import { TokenService } from '../token.service';
import { Team } from '@app/shared/models/team';

@Injectable({
    providedIn: 'root'
})
export class ResolveTeamsService {

    constructor(
        private readonly store$: Store<fromRoot.State>,
        private tokenService: TokenService,
    ) { }

    resolve(): Observable<{ isLoggedIn: boolean, selectedTeam?: Team }> {
        const resolvedTeams$ = new ReplaySubject<{ isLoggedIn: boolean, selectedTeam?: Team }>();
        this.store$.pipe(
            withLatestFrom(
                this.store$.select(fromRoot.getActiveIdentity),
                this.store$.select(fromRoot.getActiveTeam),
                this.store$.select(fromRoot.getUserRolesLoading),
                this.store$.select(fromRoot.getUserRolesLoaded),
                this.store$.select(fromRoot.getUserTeamsLoading),
                this.store$.select(fromRoot.getUserTeamsLoaded),
            ),
            takeUntil(resolvedTeams$)
        ).subscribe(([store, identity, activeTeam, rolesLoading, rolesLoaded, teamsLoading, teamsLoaded]) => {
            const isRoot = this.tokenService.isRoot(identity.token.token);
            if (!!identity.username) {
                if (!teamsLoading && teamsLoaded) {
                    resolvedTeams$.next({ isLoggedIn: true, selectedTeam: activeTeam });
                } else if (!teamsLoading && !teamsLoaded && (isRoot || rolesLoaded)) {
                    this.store$.dispatch(AccountActions.LoadUserTeams());
                } else if (!teamsLoading && !rolesLoading && !rolesLoaded) {
                    this.store$.dispatch(AccountActions.LoadUserRoles());
                }
            } else {
                resolvedTeams$.next({ isLoggedIn: false });
            }
        });

        return resolvedTeams$.asObservable();
    }
}
